var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0088 50.0176C46.7295 50.0176 40.0176 56.7295 40.0176 65.0088C40.0176 73.2882 46.7295 80.0001 55.0088 80.0001C63.2882 80.0001 70.0001 73.2882 70.0001 65.0088C70.0001 56.7295 63.2882 50.0176 55.0088 50.0176ZM62.4721 69.149L59.1576 72.4635L55.0087 68.3146L50.8598 72.4635L47.5452 69.149L51.6943 65.0001L47.5454 60.8512L50.8599 57.5366L55.0088 61.6855L59.1577 57.5366L62.4723 60.8512L58.3234 65.0001L62.4721 69.149Z",
    fill: "#EA501F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10V70H35.9694C35.5527 68.4059 35.33 66.7334 35.33 65.0088C35.33 55.8714 41.5578 48.1895 50 45.9741V27.3438H32.6563V10H0ZM7.51031 17.6563H22.4895V22.3438H7.51031V17.6563ZM7.51031 27.6563H30V32.3438H7.51031V27.6563ZM30 62.3438H7.51031V57.6563H30V62.3438ZM37.4897 52.3438H7.51031V47.6563H37.4895L37.4897 52.3438ZM42.4897 37.6563V42.3438H7.51031V37.6563H42.4897Z",
    fill: "#EA501F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3438 12.3438V22.6563H47.6563L37.3438 12.3438Z",
    fill: "#EA501F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3438 2.34375V12.6563H57.6563L47.3438 2.34375Z",
    fill: "#EA501F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9416 5.3125L42.6563 11.027V0H10V5.3125H36.9416Z",
    fill: "#EA501F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9729 17.3438L54.6874 23.0584V45.3341C56.2484 45.2975 58.3213 45.5206 59.9999 45.9694V17.3438H48.9729Z",
    fill: "#EA501F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocuments);
export default __webpack_public_path__ + "static/media/no-documents.1174dd556ace2a27151307525bfe0a2d.svg";
export { ForwardRef as ReactComponent };